import { Suspense, useEffect, useState } from "react";
// Router
import {
    BrowserRouter,
    Redirect,
    Route,
    Switch
} from "react-router-dom";
import themeConfig from "../configs/themeConfig";
import FullLayout from "../layout/FullLayout";
import HorizontalLayout from "../layout/HorizontalLayout";
// Layouts
import VerticalLayout from "../layout/VerticalLayout";
import Error404 from "../view/error";
import Error403 from "../view/error/error403";
// Components
import HomePage from "../view/home";
// Routes
import { Routes } from "./routes";


export default function Router() {

    const [isPageAuthorization, setisPageAuthorization] = useState(true);

    // Dark Mode
    useEffect(() => {
        document.querySelector("body").classList.add(themeConfig.theme)
    }, [])

    // RTL
    useEffect(() => {
        if (themeConfig.direction == "ltr") {
            document.querySelector("html").setAttribute("dir", "ltr");
        } else if (themeConfig.direction == "rtl") {
            document.querySelector("html").setAttribute("dir", "rtl");
        }
    }, [])

    // Default Layout
    const DefaultLayout = themeConfig.layout; // FullLayout or VerticalLayout

    // All of the available layouts
    const Layouts = { VerticalLayout, HorizontalLayout, FullLayout };

    // Return Filtered Array of Routes & Paths
    const LayoutRoutesAndPaths = (layout) => {
        const LayoutRoutes = [];
        const LayoutPaths = [];
        if (Routes) {
            // Checks if Route layout or Default layout matches current layout
            Routes.filter(route => (route.layout === layout) && (
                LayoutRoutes.push(route),
                LayoutPaths.push(route.path)
            ));
        }

        return { LayoutRoutes, LayoutPaths };
    };

    // Return Route to Render
    const ResolveRoutes = () => {
        return Object.keys(Layouts).map((layout, index) => {
            const { LayoutRoutes, LayoutPaths } = LayoutRoutesAndPaths(layout);

            let LayoutTag;
            if (DefaultLayout == "HorizontalLayout") {
                if (layout == "VerticalLayout") {
                    LayoutTag = Layouts["HorizontalLayout"];
                } else {
                    LayoutTag = Layouts[layout];
                }
            } else {
                LayoutTag = Layouts[layout];
            }

            return (
                <Route path={LayoutPaths} key={index}>
                    <LayoutTag>
                        <Switch>
                            {LayoutRoutes.map((route) => {
                                return (
                                    <Route
                                        key={route.path}
                                        path={route.path}
                                        exact={route.exact === true}
                                        render={(props) => {
                                            return (
                                                <Suspense fallback={null}>
                                                    <route.component {...props} />
                                                </Suspense>
                                            );
                                        }}
                                    />
                                );
                            })}
                        </Switch>
                    </LayoutTag>
                </Route>
            );
        });
    };

    const PageAuthorization = (e) => {
        // if (e.path === "/") {
          setisPageAuthorization(true);
        // }
        // else {
        //   let path=e.path;
    
        //   if (e.path === "/usermenumapping") {
        //     path='/useraccess';
        //   }
    
        //   APIService.post(pageauthorizationUrl + path)
        //     .then(res => {
        //       if (!res.data.isError) {
        //         setisPageAuthorization(res.data.data);
        //       } else {
        //         setisPageAuthorization(false);
        //       }
        //     }).catch(error => {
        //       setisPageAuthorization(false)
        //     });
        // }
        // // return true;
      }
    
    return (
        <BrowserRouter>
            <Switch>
                {/* Auth Guarded Routes */}
                {Routes.map((route) => {
                    let RouteLayout = Layouts[route.layout];
                    if (route.pageType === "private") {
                        return (
                            <Route
                                path={route.path}
                                exact={route.exact === true}
                                render={(props) => {
                                    let isUserAuthenticated =
                                        !!sessionStorage.token || !!localStorage.token;
                                    if (isUserAuthenticated) {
                                        PageAuthorization(route);
                                        if (isPageAuthorization) {
                                            return (
                                                <Suspense fallback={null}>
                                                    <RouteLayout>
                                                        <route.component {...props} />
                                                    </RouteLayout>
                                                </Suspense>
                                            );
                                        }
                                        else {
                                            return <Redirect to="/forbidden" />;
                                        }
                                    } else {
                                        return <Redirect to="/" />;
                                    }
                                }}
                            />
                        );
                    } else if (route.pageType === "authentication") {
                        return (
                            <Route
                                path={route.path}
                                exact={route.exact === true}
                                render={(props) => {
                                    let isUserAuthenticated =
                                        !!sessionStorage.token || !!localStorage.token;
                                    if (!isUserAuthenticated) {
                                        return (
                                            <Suspense fallback={null}>
                                                <RouteLayout>
                                                    <route.component {...props} />
                                                </RouteLayout>
                                            </Suspense>
                                        );
                                    } else {
                                        return <Redirect to="/home" />;
                                    }
                                }}
                            />
                        );
                    } else {
                        return (
                            <Route
                                path={route.path}
                                exact={route.exact === true}
                                render={(props) => {
                                    return (
                                        <Suspense fallback={null}>
                                            <RouteLayout>
                                                <route.component {...props} />
                                            </RouteLayout>
                                        </Suspense>
                                    );
                                }}
                            />
                        );
                    }
                })}
                <Route path="/forbidden">
                    <Error403 />
                </Route>
                <Route path="*">
                    <Error404 />
                </Route>
            </Switch>
        </BrowserRouter>
    );
};